import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../configurations/firebaseConfig";
import LandingScreen from "../landing/view/LandingScreen";
import MainScreen from "./MainScreen";

// 로그인하지 않은 방문자에게도 열려 있어야 하는 경로이므로,
// 로그인 상태일 때만 MainScreen을 보여주고 그 외에는 랜딩페이지를 보여준다.
function RootScreen() {
  const [isSignedIn, setIsSignedIn] = useState<boolean>();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsSignedIn(user !== null);
    });

    return () => unsubscribe();
  }, []);

  if (isSignedIn === undefined) {
    return null;
  }

  return isSignedIn === true ? <MainScreen /> : <LandingScreen />;
}

export default RootScreen;
